import { InvoiceDetail } from "../models/Invoice";
import { GET_INVOICE_BY_BOOKINGID, SEND_INVOICE_TO_WHATSAPP } from "./queries";
import client from "./apolloClient";
import { AppContext } from "./AppContext"

export const getInvoiceByBookingId = async (bookingId: string): Promise<InvoiceDetail | null> => {
    try {
        const { data } = await client.query({
            query: GET_INVOICE_BY_BOOKINGID,
            variables: { bookingId },
            context: {
                headers: {
                    // Authorization:  AppContext.loggedAuthToken  ? `Bearer ${ AppContext.loggedAuthToken }` : '',
                },
            }
        });
        return data?.getInvoiceByBookingId;
    } catch (error) {
        //  console.error('Error fetching getInvoiceByBookingId:', error);
        console.log("Error fetching getInvoiceByBookingId: " + error)
        return null;
    }
}

export const sendInvoiceToUserWhatsApp = async (bookingId: string): Promise<InvoiceDetail | null> => {
    try {
        const { data } = await client.query({
            query: SEND_INVOICE_TO_WHATSAPP,
            variables: { bookingId },
            context: {
                headers: {
                    Authorization: AppContext.loggedAuthToken ? `Bearer ${AppContext.loggedAuthToken}` : '',
                },
            }
        });
        return data?.sendInvoiceToUserWhatsApp;
    } catch (error) {
        console.log("Error fetching sendInvoiceToUserWhatsApp: " + error)
        return null;
    }
}



